import { ValidatorFn, Validators } from '@angular/forms';

const commonEmailDomains = [
  'gmail.com', 'hotmail.com', 'outlook.com', 'yahoo.com',
  'icloud.com', 'live.com', 'msn.com', 'aol.com', 'mail.com',
];

// A heuristic for likely typos, not proof that a domain or mailbox exists.
// Match one replacement, missing/extra character, or adjacent transposition.
function isSingleEditAway(value: string, expected: string): boolean {
  if (Math.abs(value.length - expected.length) > 1) return false;
  let index = 0;
  while (index < value.length && value[index] === expected[index]) index++;
  if (value.length === expected.length) {
    return value.slice(index + 1) === expected.slice(index + 1)
      || (value[index] === expected[index + 1]
        && value[index + 1] === expected[index]
        && value.slice(index + 2) === expected.slice(index + 2));
  }
  return value.length > expected.length
    ? value.slice(index + 1) === expected.slice(index)
    : value.slice(index) === expected.slice(index + 1);
}

function suggestDomain(domain: string): string | undefined {
  if (commonEmailDomains.includes(domain)) return undefined;
  const matches = commonEmailDomains.filter(candidate => isSingleEditAway(domain, candidate));
  // Do not guess when more than one provider matches.
  return matches.length === 1 ? matches[0] : undefined;
}

export const registrationEmailValidator: ValidatorFn = control => {
  if (!control.value) return null; // Required is handled separately.
  if (Validators.email(control)) return { email: true };
  const domain = String(control.value).split('@')[1]?.toLowerCase() ?? '';
  if (!/^(?:[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\.)+[a-z]{2,63}$/.test(domain)) {
    return { email: true };
  }
  const suggestion = suggestDomain(domain);
  return suggestion ? { emailDomainTypo: { suggestion } } : null;
};
